import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=6b410f98"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b410f98')) {
      api.createRecord('6b410f98', component.options)
    } else {
      api.reload('6b410f98', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=6b410f98", function () {
      api.rerender('6b410f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operations/workshop/Main.vue"
export default component.exports